/* eslint-disable */
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import JoditEditor from "jodit-react";

import * as url from "helper/UrlHelper";
import { getData, postData, uploadSingleFile } from "utils/Gateway";

import { assetImages } from "constants";
import languageOptions from "data/Prod/LanguageOptions.json";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import { ecosystemSlug, reactSelectStyle } from "Config/Config";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { getMemberOptions } from "helper/ContactHelper/ContactHelper";
import AfterSaveUserModal from "../Modal/AfterSaveUserModal";

const CreateNewUserForm = ({ moduleName = "" }) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const editor = useRef(null);
  const profileImageRef = useRef(null);

  /* ========= use states =========== */
  //state for user search
  const [userValue, setUserValue] = useState(null);
  const [ecosystemList, setEcosystemList] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [interestList, setInterestList] = useState([]);
  const [serviceList, setServiceList] = useState(
    []
  ); /* New state for services */
  const [treatmentList, setTreatmentList] = useState([]);
  const [specialityList, setSpecialityList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [companyInput, setcompanyInput] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [mentorInput, setMentorInput] = useState("");
  const [mentorList, setMentorList] = useState([]);

  const [profilePic, setProfilePic] = useState("");
  const [profilePicId, setProfilePicId] = useState(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [position, setPosition] = useState("");
  const [companyValue, setCompanyValue] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [mentorValue, setMentorValue] = useState(null);
  const [mentorId, setMentorId] = useState(null);
  const [bioDetails, setBioDetails] = useState("");
  const [address, setAddress] = useState("");
  const [rate, setRate] = useState(0);
  const [skillValue, setSkillValue] = useState(null);
  const [skills, setSkills] = useState([]);
  const [interestValue, setInterestValue] = useState(null);
  const [interest, setInterest] = useState([]);
  const [serviceValue, setServiceValue] =
    useState(null); /* New state for selected services */
  const [services, setServices] = useState(
    []
  ); /* New state for services to send to API */
  const [treatmentValue, setTreatmentValue] = useState(null);
  const [treatments, setTreatments] = useState([]);
  const [specialityValue, setSpecialityValue] = useState(null);
  const [specialities, setSpecialities] = useState([]);
  const [languageValue, setLanguageValue] = useState(null);
  const [language, setLanguage] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const [stateName, setstateName] = useState("");
  const [cityName, setcityName] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [ecosystemValue, setEcosystemValue] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [dob, setDob] = useState(""); // Add dob state
  // --- Banner Image and AI Video states ---
  const [bannerImage, setBannerImage] = useState("");
  const [bannerImageId, setBannerImageId] = useState(null);
  const [isBannerUploading, setIsBannerUploading] = useState(false);
  const [aiVideo, setAiVideo] = useState("");
  const [aiVideoId, setAiVideoId] = useState(null);
  const [isVideoUploading, setIsVideoUploading] = useState(false);

  const [errors, setErrors] = useState({});

  const [savedUserId, setsavedUserId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // const editorCustomConfig = joditEditorConfig();
  const aboutEditorCustomConfig = {
    readonly: false,
    placeholder: "",
    minHeight: 300,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;

              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setBioDetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const aboutEditorConfig = useMemo(() => aboutEditorCustomConfig, []);

  /* Validation function */
  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = t("Please enter your name.");
    }

    if (!email.trim()) {
      newErrors.email = t("Please enter your email address.");
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = t("Please enter a valid email address.");
    }

    if (!ecosystemValue) {
      newErrors.ecosystem = t("Please select an ecosystem.");
    }

    if (!roleValue) {
      newErrors.role = t("Please select a user role.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUserSearch = async (userInput) => {
    // Only call API if userInput matches email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    // if (!emailRegex.test(userInput)) {
    //   return [];
    // }
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST +
        `?token=${token}&userstring=${userInput}&modulefrom=backend&filterroleslug=${moduleName}`;

      const response = await getData(requestUrl);

      if (response.status) {
        return response.data;
      }
    } catch (error) {
      // console.log(error.message);
      return [];
    }
  };

  //** function for get all modules
  const getAllEcosystems = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_ECOSYSTEM + `?token=${token}`;

      // console.log(requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in ecosystem list------>", response);

      if (response.status) {
        const ecosystemOptions = response.data.map((item) => ({
          label: item.name,
          value: item._id,
        }));
        setEcosystemList(ecosystemOptions);

        const defualtEcosystem = response.data.find(
          (item) => item.slug === ecosystemSlug
        );

        if (defualtEcosystem) {
          setEcosystemValue({
            label: defualtEcosystem.name,
            value: defualtEcosystem._id,
          });
        }
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  //function for get all mentors
  const getAllMentors = async () => {
    try {
      const data = await getMemberOptions(mentorInput);

      if (data.length > 0) {
        setMentorList(data);
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  //function for get all categories
  const getAllSkills = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CATEGORIES +
        `?token=${token}&slug=skills&ecosystemslug=${ecosystemSlug}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setSkillList(response.data);
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  const getAllInterests = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CATEGORIES +
        `?token=${token}&slug=interests&ecosystemslug=${ecosystemSlug}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setInterestList(response.data);
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  //function for get all services
  const getAllServices = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CATEGORIES +
        `?token=${token}&slug=services&ecosystemslug=${ecosystemSlug}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setServiceList(response.data);
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  //function for get all treatments
  const getAllTreatments = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CATEGORIES +
        `?token=${token}&slug=TREATMENT&ecosystemslug=${ecosystemSlug}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setTreatmentList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all specialities
  const getAllSpecialities = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CATEGORIES +
        `?token=${token}&slug=	speciality&ecosystemslug=${ecosystemSlug}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setSpecialityList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all user roles
  const getAllRoles = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_ROLES + `?token=${token}`;

      //console.log('all roles', requestUrl);

      const response = await getData(requestUrl);

      if (response.status) {
        setRoleList(response.data);

        const defualtRole = response.data.find(
          (item) => item.slug === moduleName
        );

        if (defualtRole) {
          roleSelectionHandler(defualtRole);
        }
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  //function for get all companies
  const getCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_BY_SEARCH +
        `?token=${token}&filtername=${companyInput}`;

      // console.log("url of company------>", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in company------>", response);

      if (response.status) {
        setCompanyList(
          response.data.map((item) => ({
            label: item.name,
            value: item.name,
          }))
        );
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  /* function to fetch location from zip code */
  const getLocationFromZip = async (e) => {
    e.preventDefault();

    if (zipcode !== "") {
      try {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${zipcode}&region=es&key=AIzaSyDt4dbtdHCHLj8grTzTVxpztvqUGDkvkaI`;

        const response = await getData(url);

        if (response.status === "OK") {
          const results = response.results;

          if (results.length > 0) {
            results[0]?.address_components.map((item) => {
              // console.log(`item`, JSON.stringify(item));
              if (item.types[0] === "country") {
                setcountry(item?.long_name);
              }
              if (item.types[0] === "locality") {
                setcityName(item?.long_name);
              }
              if (item.types[0] === "administrative_area_level_1") {
                setstateName(item?.long_name);
              }
            });
            // setMapCoordinate(
            //   `https://maps.google.com/maps?q=${results[0]?.geometry?.location?.lat},${results[0]?.geometry?.location?.lng}`
            // );
          } else {
            // console.log("No results found.");
          }
        } else {
          // console.log("Request failed with status:", response.status);
        }
      } catch (error) {
        console.error("Error:", error.message);
      }
    }
  };

  //function for open cover image file input
  const profileImageOpen = () => {
    profileImageRef.current.click();
  };

  //function for upload cover image
  const profileImageUploadHandler = async (e) => {
    const file = e.target.files[0];

    setIsImageUploading(true);

    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadSingleFile(requestUrl, file);

      // console.log("upload response-------->", response);

      if (response.status) {
        setIsImageUploading(false);
        setProfilePic(response.data.path);
        setProfilePicId(response.data._id);
        resetProfileImageFile();
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // function for clear file value
  const resetProfileImageFile = () => {
    const file = document.getElementById("uploadprofileimage");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //function for select skills
  const skillSelectionHandler = (val) => {
    setSkillValue(val);
    const valArr = val.map((item) => item.value);
    setSkills(valArr);
  };

  //function for select interest
  const interestSelectionHandler = (val) => {
    setInterestValue(val);
    const valArr = val.map((item) => item.value);
    setInterest(valArr);
  };

  //function for select language
  const languageSelectionHandler = (val) => {
    setLanguageValue(val);
    setLanguage(val?.value);
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    setRoleValue(val);
    setRoleId(val.value);
  };

  //function for select services
  const serviceSelectionHandler = (val) => {
    setServiceValue(val);
    const valArr = val.map((item) => item.value);
    setServices(valArr);
  };

  //function for select treatments
  const treatmentSelectionHandler = (val) => {
    setTreatmentValue(val);
    const valArr = val.map((item) => item.value);
    setTreatments(valArr);
  };

  //function for select specialities
  const specialitySelectionHandler = (val) => {
    setSpecialityValue(val);
    const valArr = val.map((item) => item.value);
    setSpecialities(valArr);
  };

  //select company
  const companySelectionHandler = (val) => {
    if (val) {
      setCompanyValue(val);
      setCompanyName(val.value);
    } else {
      setCompanyValue(null);
      setCompanyName("");
    }
  };

  const mentorSelectionHandler = (val) => {
    if (val) {
      setMentorValue(val);
      setMentorId(val.value);
    } else {
      setMentorValue(null);
      setMentorId(null);
    }
  };

  // --- Banner Image handlers ---
  const bannerImageUploadHandler = async (file) => {
    setIsBannerUploading(true);
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD + `?token=${token}`;
      const response = await uploadSingleFile(requestUrl, file[0]);
      setIsBannerUploading(false);
      if (response.status) {
        setBannerImage(url.SERVER_URL + response.data.path);
        setBannerImageId(response.data._id);
      }
    } catch (error) {
      console.error(error.message);
      setIsBannerUploading(false);
    }
  };

  const removeBannerImageHandler = () => {
    setBannerImage("");
    setBannerImageId(null);
  };

  // --- AI Video handlers ---
  const aiVideoUploadHandler = async (videoData) => {
    setIsVideoUploading(true);
    try {
      const requestUrl = `${url.API_BASE_URL}${url.API_SINGLE_FILE_UPLOAD}?token=${token}`;
      const response = await uploadSingleFile(requestUrl, videoData[0]);
      if (response.status) {
        setAiVideo(url.SERVER_URL + response.data.path);
        setAiVideoId(response.data._id);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsVideoUploading(false);
    }
  };

  const removeAiVideoHandler = () => {
    setAiVideo("");
    setAiVideoId(null);
  };

  //function for get user details
  const getUserDetails = async (profileId) => {
    // console.log("userInfo", userInfo);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${profileId}` +
        `?token=${token}`;

      // console.log("requestUrl", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in user details", response);

      if (response.status && response.data) {
        const data = response.data;
        setsavedUserId(data._id);
        setProfilePic(data.userimage || ""); // Ensure default value if undefined
        setProfilePicId(data.userimageid || null); // Ensure default value if undefined
        setName(data.name || "");
        setSurName(data.surname || "");
        setEmail(data.email || "");
        setTelephone(data.phone || "");
        setPosition(data.position || "");
        const companyResponse = data.company
          ? {
              label: data.company,
              value: data.company,
            }
          : null;
        companySelectionHandler(companyResponse);
        setBioDetails(data.about || "");
        setAddress(data.address || "");
        setRate(data.costperhour);
        const skillData = data.userskills || [];
        skillSelectionHandler(skillData);
        const interestData = data.userinterests || [];
        interestSelectionHandler(interestData);

        const serviceData = data.userservices || [];
        serviceSelectionHandler(serviceData);

        const treatmentData = data.usertreatments || [];
        treatmentSelectionHandler(treatmentData);
        const specialityData = data.userspecialities || [];
        specialitySelectionHandler(specialityData);

        const matchedLanguage = languageOptions.find(
          (language) => language.value === data.language
        );
        if (matchedLanguage) {
          languageSelectionHandler(matchedLanguage);
        }
        setstateName(data.state || "");
        setcityName(data.city || "");
        setcountry(data.country || "");
        setzipcode(data.zipcode || "");
        setDob(data.dob || ""); // Set dob from API
        if (response.data.mentorvalue) {
          mentorSelectionHandler(response.data.mentorvalue);
        }
        setBannerImage(
          data.bannerimagepath ? url.SERVER_URL + data.bannerimagepath : ""
        );
        setBannerImageId(data.bannerimageid || null);
        setAiVideo(
          response.data?.aivideopath
            ? url.SERVER_URL + response.data?.aivideopath
            : ""
        );
        setAiVideoId(response.data?.aivideoid || null);
      }
    } catch (error) {
      // console.log(error.message);
    }
  };

  const resetUserFormStates = () => {
    setsavedUserId(null);
    setUserValue(null);
    setProfilePic("");
    setProfilePicId(null);
    setName("");
    setSurName("");
    setEmail("");
    setTelephone("");
    setPosition("");
    companySelectionHandler(null);
    setBioDetails("");
    setAddress("");
    setRate(0);
    skillSelectionHandler([]);
    interestSelectionHandler([]);
    serviceSelectionHandler([]);
    treatmentSelectionHandler([]);
    specialitySelectionHandler([]);
    languageSelectionHandler(null);
    setstateName("");
    setcityName("");
    setcountry("");
    setzipcode("");
    setDob(""); // Reset dob
    mentorSelectionHandler(null);
    setBannerImage("");
    setBannerImageId(null);
    setAiVideo("");
    setAiVideoId(null);
  };

  //function for save/update user
  const saveUserHandler = async () => {
    if (!validateForm()) {
      window.scrollTo(0, 0);
      setAlertMessage(t("Please fill up the required fields"));
      setMessageType("error");
      setShowAlert(true);
      return;
    }

    try {
      setIsSaving(true);
      let userData = {
        _id: savedUserId,
        ecosystemid: ecosystemValue ? ecosystemValue.value : null,
        photoimage: profilePicId,
        name,
        surname: surName,
        email,
        position,
        company: companyName,
        mentorid: mentorId,
        language,
        role: roleId,
        phone: telephone,
        position,
        dob, // Add dob to API payload
        address,
        about: bioDetails,
        city: cityName,
        state: stateName,
        country,
        zipcode,
        adminstatus: "1",
        costperhour: rate,
        skills,
        interests: interest,
        services,
        treatments, // Add treatments to payload
        specialities, // Add specialities to payload
        rank: 1,
        status: "1",
        // --- Banner Image and AI Video fields ---
        bannerimage: bannerImageId || null,
        aivideo: aiVideoId || null,
      };

      console.log("userData for save", userData);

      const requestUrl =
        url.API_BASE_URL + url.API_ADD_NEW_USER_AND_CONTACT + `?token=${token}`;

      const response = await postData(requestUrl, userData);

      if (response.status) {
        setsavedUserId(response.data);

        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSaveUserModal")
        );
        bootstrapModal.show();
      }
    } catch (error) {
      console.log(error.message);
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    } finally {
      setIsSaving(false);
    }
  };

  //after modal close
  const afterModalClose = () => {
    if (moduleName === "DOCTOR") {
      history.push("/admin/clinicalmanagement/doctors");
    } else {
      history.push("/admin/clinicalmanagement/patients");
    }
  };

  useEffect(() => {
    getAllSkills();
    getAllInterests();
    getAllServices();
    getAllRoles();
    getAllEcosystems();
    getAllTreatments(); // Add treatments fetch
    getAllSpecialities(); // Add specialities fetch
  }, []);

  useEffect(() => {
    if (companyInput.length > 1) {
      getCompanyList();
    }
  }, [companyInput]);

  const companyOptionsToShow = companyList.length > 0 ? companyList : [];

  useEffect(() => {
    if (mentorInput.length > 1) {
      getAllMentors();
    }
  }, [mentorInput]);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const customStyle = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.ecosystem || errors.role ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.ecosystem || errors.role ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_CREATE_DOCTOR") ||
    moduleAccess.includes("MOD_CREATE_PATIENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={moduleName === "DOCTOR" ? t("Doctor") : t("Patient")}
          />
          <div className="container-fluid px-lg-5">
            <div className="container-fluid d-flex align-items-center gap-2 gap-sm-4 px-lg-3 my-3">
              <Link
                to={
                  moduleName === "DOCTOR"
                    ? "/admin/clinicalmanagement/doctors"
                    : "/admin/clinicalmanagement/patients"
                }
                className="back-btn d-flex flex-shrink-0 align-items-center justify-content-center body-bg text-gray rounded-circle"
              >
                <span className="d-block material-symbols-outlined">
                  arrow_back
                </span>
              </Link>
            </div>

            {/* --- add/update section start----- */}
            <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="name"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Search by email")}
                  </label>
                  <AsyncSelect
                    isClearable
                    cacheOptions={false}
                    defaultOptions={[]}
                    placeholder={t("Search by email")}
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    loadOptions={handleUserSearch}
                    value={userValue}
                    onChange={(val) => {
                      if (val) {
                        setUserValue(val);
                        getUserDetails(val.value);
                      } else {
                        resetUserFormStates();
                      }
                    }}
                  />
                </div>

                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label htmlFor="name" className="d-block fs-sm fw-semibold">
                    {t(
                      `${
                        moduleName === "DOCTOR" ? "Doctor" : "Patient"
                      } not found? Fill the form below to create a new ${
                        moduleName === "DOCTOR" ? "doctor" : "patient"
                      }`
                    )}
                  </label>
                </div>

                {/* --- user's image ---- */}
                <div className="form-group mb-3 mb-sm-4">
                  <div
                    className="avatar-container position-relative rounded-circle overflow-hidden"
                    style={{ width: "120px", height: "120px" }}
                  >
                    <img
                      src={
                        profilePic == ""
                          ? assetImages.defaultUser
                          : url.SERVER_URL + profilePic
                      }
                      className="w-100 h-100 object-fit-cover object-center"
                      alt="Expert"
                    />
                    <Link
                      to="#"
                      onClick={profileImageOpen}
                      id="uploadAvatar"
                      className="block text-center text-white px-3 py-2 position-absolute start-0 end-0 bottom-0"
                      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                    >
                      <span className="d-block material-symbols-outlined icon-lg">
                        photo_camera
                      </span>
                    </Link>
                    <input
                      onChange={profileImageUploadHandler}
                      ref={profileImageRef}
                      type="file"
                      id="uploadprofileimage"
                      className="d-none"
                      accept="image/*"
                    />
                  </div>
                </div>

                {/* ---- name / surname ------ */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <label
                        htmlFor="name"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Name")}*
                      </label>
                      <input
                        type="text"
                        id={name}
                        className={`form-control fs-sm shadow-none ${
                          errors.name ? "is-invalid" : "border border-gray-300"
                        }`}
                        placeholder={t("e.g., John")}
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          if (errors.name) {
                            setErrors((prev) => ({ ...prev, name: "" }));
                          }
                        }}
                      />

                      {errors.name && (
                        <div className="invalid-feedback">{errors.name}</div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <label
                        htmlFor="surname"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Surname")}*
                      </label>
                      <input
                        type="text"
                        id="surname"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("e.g., Doe")}
                        value={surName}
                        onChange={(e) => setSurName(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* ----- email in its own row ------- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    <div className="col-lg-12 mb-3 mb-sm-3 mb-lg-0">
                      <label
                        htmlFor="email"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Email")}*
                      </label>
                      <input
                        type="email"
                        id="email"
                        className={`form-control fs-sm shadow-none ${
                          errors.email ? "is-invalid" : "border border-gray-300"
                        }`}
                        placeholder={t("e.g., john.doe@example.com")}
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          if (errors.email) {
                            setErrors((prev) => ({ ...prev, email: "" }));
                          }
                        }}
                      />
                      {errors.email && (
                        <div className="invalid-feedback">{errors.email}</div>
                      )}
                    </div>
                  </div>
                </div>

                {/* ----- telephone / position / dob ------- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    <div className="col-lg-4 mb-3 mb-sm-3 mb-lg-0">
                      <label
                        htmlFor="telephone"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Telephone")}
                      </label>
                      <input
                        type="tel"
                        id="telephone"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("e.g., +1234567890")}
                        value={telephone}
                        onChange={(e) => setTelephone(e.target.value)}
                      />
                    </div>
                    <div className="col-lg-4 mb-3 mb-sm-3 mb-lg-0">
                      <label
                        htmlFor="position"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Position")}
                      </label>
                      <input
                        type="text"
                        id="position"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("e.g., Software Engineer")}
                        value={position}
                        onChange={(e) => setPosition(e.target.value)}
                      />
                    </div>
                    <div className="col-lg-4">
                      <label
                        htmlFor="dob"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Date of Birth")}
                      </label>
                      <input
                        type="date"
                        id="dob"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("e.g., 1990-01-01")}
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                {/* company and logo start */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    {/* company name */}
                    <div className="col-lg-6 mb-3 mb-lg-0">
                      <label
                        htmlFor="companyName"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Clinic Name")}
                      </label>
                      <CreatableSelect
                        id="companyName"
                        placeholder={t("Start typing to find or add a company")}
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        isClearable
                        options={companyOptionsToShow}
                        value={companyValue}
                        onChange={(val) => {
                          companySelectionHandler(val);
                        }}
                        onInputChange={(val) => {
                          setcompanyInput(val);
                        }}
                      />
                    </div>
                    {/* mentor */}
                    <div className="col-lg-6">
                      <label
                        htmlFor="mentor"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Mentor")}
                      </label>
                      <Select
                        isClearable
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        placeholder={t("Search by name, email")}
                        options={mentorList}
                        value={mentorValue}
                        onChange={(val) => mentorSelectionHandler(val)}
                        onInputChange={(val) => setMentorInput(val)}
                      />
                    </div>
                  </div>
                </div>
                {/* company and logo end */}

                {/* ecosystem and role */}
                <div
                  className={
                    userInfo.role.slug === "ADMIN" ||
                    userInfo.role.slug === "SUPER_ADMIN"
                      ? "form-group mb-4 p-3 border rounded-8 shadow-sm bg-white"
                      : "d-none"
                  }
                >
                  <div className="row">
                    <div
                      className={
                        userInfo.role && userInfo.role.slug == "SUPER_ADMIN"
                          ? "col-lg-6 mb-3 mb-sm-6 mb-lg-0"
                          : "d-none"
                      }
                    >
                      <label
                        htmlFor="bioDetails"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Ecosystem")}
                      </label>
                      <Select
                        placeholder={t("Please select an ecosystem")}
                        options={ecosystemList}
                        value={ecosystemValue}
                        onChange={(val) => {
                          setEcosystemValue(val);
                          if (errors.ecosystem) {
                            setErrors((prev) => ({ ...prev, ecosystem: "" }));
                          }
                        }}
                        styles={customStyle}
                      />
                      {errors.ecosystem && (
                        <div className="invalid-feedback d-block">
                          {errors.ecosystem}
                        </div>
                      )}
                    </div>

                    {/* ----- select role ----- */}
                    <div
                      className={
                        userInfo.role &&
                        (userInfo.role.slug == "SUPER_ADMIN" ||
                          userInfo.role.slug == "ADMIN")
                          ? `${
                              userInfo.role.slug == "ADMIN"
                                ? "col-lg-12"
                                : "col-lg-6"
                            } mb-3 mb-sm-6 mb-lg-0`
                          : "d-none"
                      }
                    >
                      <label
                        htmlFor="Role"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Select Role")}
                      </label>
                      <Select
                        styles={customStyle}
                        placeholder={t("Please select a user role")}
                        options={roleList}
                        value={roleValue}
                        onChange={(val) => {
                          roleSelectionHandler(val);
                          if (errors.role) {
                            setErrors((prev) => ({ ...prev, role: "" }));
                          }
                        }}
                      />
                      {errors.role && (
                        <div className="invalid-feedback d-block">
                          {errors.role}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* ------- bio details -------- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="bioDetails"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("About")}
                  </label>
                  <JoditEditor
                    ref={editor}
                    value={bioDetails}
                    config={aboutEditorConfig} //{joditconfig}
                    onBlur={(newContent) => {
                      // console.log("New content in on blur----->", newContent);
                      setBioDetails(newContent);
                    }}
                    onChange={(newContent, event) => {
                      // setdetails(newContent);
                    }}
                  />
                </div>

                {/* ------ zipcode,location,city,country ----- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    {/* ----- zipcode section start ------ */}
                    <div className="col-lg-4 mb-3 mb-lg-0">
                      <label
                        htmlFor="zipcode"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Zipcode")}
                      </label>
                      <div className="row g-2">
                        <div className="col">
                          <input
                            type="text"
                            id="zipcode"
                            className="form-control shadow-none border border-gray-300"
                            placeholder={t("e.g., 90210")}
                            value={zipcode}
                            onChange={(e) => {
                              setzipcode(e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-auto">
                          <button
                            className="btn btn-primary"
                            onClick={getLocationFromZip}
                          >
                            {t("Fetch Location by zipcode")}
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* ----- zipcode section end ------ */}
                    {/* ----- city,state,country section start ------ */}
                    <div className="col-lg-8">
                      <div className="row">
                        {/* ----- city section start ------ */}
                        <div className="col-lg-4 mb-3 mb-lg-0">
                          <label
                            htmlFor="cityName"
                            className="d-block fs-sm fw-semibold mb-2"
                          >
                            {t("City")}
                          </label>
                          <input
                            type="text"
                            id="cityName"
                            className="form-control border border-gray-300 shadow-none"
                            placeholder={t("e.g., Los Angeles")}
                            value={cityName}
                            onChange={(e) => {
                              setcityName(e.target.value);
                            }}
                          />
                        </div>
                        {/* ----- city section end ------ */}
                        {/* ----- state section start ------ */}
                        <div className="col-lg-4 mb-3 mb-lg-0">
                          <label
                            htmlFor="stateName"
                            className="d-block fs-sm fw-semibold mb-2"
                          >
                            {t("State")}
                          </label>
                          <input
                            type="text"
                            id="stateName"
                            className="form-control border border-gray-300 shadow-none"
                            placeholder={t("e.g., California")}
                            value={stateName}
                            onChange={(e) => {
                              setstateName(e.target.value);
                            }}
                          />
                        </div>
                        {/* ----- state section end ------ */}
                        {/* ----- country section start ------ */}
                        <div className="col-lg-4">
                          <label
                            htmlFor="country"
                            className="d-block fs-sm fw-semibold mb-2"
                          >
                            {t("Country")}
                          </label>
                          <input
                            type="text"
                            id="country"
                            className="form-control border border-gray-300 shadow-none"
                            placeholder={t("e.g., United States")}
                            value={country}
                            onChange={(e) => {
                              setcountry(e.target.value);
                            }}
                          />
                        </div>
                        {/* ----- country section end ------ */}
                      </div>
                    </div>
                    {/* ----- city,state,country section end ------ */}
                  </div>
                </div>

                {/* -------- Address and Rate Per Hour -------- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <label
                        htmlFor="address"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Address")}
                      </label>
                      <input
                        type="text"
                        className="form-control border border-gray-300 shadow-none"
                        placeholder={t("e.g., 123 Main St, Anytown")}
                        value={address}
                        onChange={(e) => {
                          setAddress(e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label
                        htmlFor="ratePerHour"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        <span>{t("Rate Per Hour")}</span>
                        <span className="ms-1 fs-xs fw-normal text-gray">
                          {t("(If working as freelancer)")}
                        </span>
                      </label>
                      <input
                        type="number"
                        min={0}
                        id="ratePerHour"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("e.g., 50")}
                        value={rate}
                        onChange={(e) => setRate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* ------- skills and services in same row --------- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    {/* Skills */}
                    <div className="col-lg-6 mb-3 mb-lg-0">
                      <label
                        htmlFor="skills"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Basic Skills")}
                      </label>
                      <Select
                        isMulti
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        placeholder={t("Select one or more skills")}
                        options={skillList}
                        value={skillValue}
                        onChange={(val) => {
                          skillSelectionHandler(val);
                        }}
                      />
                    </div>
                    {/* Services */}
                    <div className="col-lg-6">
                      <label
                        htmlFor="services"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Select Services")}
                      </label>
                      <Select
                        isMulti
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        placeholder={t("Select one or more services")}
                        options={serviceList}
                        value={serviceValue}
                        onChange={(val) => {
                          serviceSelectionHandler(val);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* ------- treatments and specialities in same row --------- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    {/* Treatments */}
                    <div className="col-lg-6 mb-3 mb-lg-0">
                      <label
                        htmlFor="treatment"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Select Treatments")}
                      </label>
                      <Select
                        isMulti
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        placeholder={t("Select one or more treatments")}
                        options={treatmentList}
                        value={treatmentValue}
                        onChange={(val) => {
                          treatmentSelectionHandler(val);
                        }}
                      />
                    </div>
                    {/* Specialities */}
                    <div className="col-lg-6">
                      <label
                        htmlFor="speciality"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Select Specialities")}
                      </label>
                      <Select
                        isMulti
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        placeholder={t("Select one or more specialities")}
                        options={specialityList}
                        value={specialityValue}
                        onChange={(val) => {
                          specialitySelectionHandler(val);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* --------- interest and language in same row --------- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row">
                    {/* Interests */}
                    <div className="col-lg-6 mb-3 mb-lg-0">
                      <label
                        htmlFor="interest"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Select Interests")}
                      </label>
                      <Select
                        isMulti
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        placeholder={t("Select one or more interests")}
                        options={interestList}
                        value={interestValue}
                        onChange={(val) => {
                          interestSelectionHandler(val);
                        }}
                      />
                    </div>
                    {/* Language */}
                    <div className="col-lg-6">
                      <label
                        htmlFor="language"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Select Language")}
                      </label>
                      <Select
                        styles={reactSelectStyle("3px", "6px", true, false)}
                        placeholder={t("Select your preferred language")}
                        options={languageOptions}
                        value={languageValue}
                        onChange={(val) => {
                          languageSelectionHandler(val);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* --- Banner Image field --- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="uploadedBannerImage"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Banner Image")}
                  </label>
                  <FileUploadField
                    label={t("Upload Banner Image")}
                    accept="jpg png jpeg"
                    onUpload={bannerImageUploadHandler}
                    files={
                      bannerImage
                        ? [{ path: bannerImage, name: "Banner Image" }]
                        : [
                            {
                              path: "https://placehold.co/150x150",
                              name: "Banner Image",
                            },
                          ]
                    }
                    onRemove={removeBannerImageHandler}
                    loading={isBannerUploading}
                    fileType="image"
                  />
                </div>

                {/* --- AI Video field --- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="aivideo"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("AI Video")}
                  </label>
                  <FileUploadField
                    label={t("Upload AI Video")}
                    accept="video/mp4,video/webm"
                    onUpload={aiVideoUploadHandler}
                    files={
                      aiVideo
                        ? [{ path: aiVideo, name: "AI Video" }]
                        : [
                            {
                              path: "https://placehold.co/300x200",
                              name: "AI Video",
                            },
                          ]
                    }
                    onRemove={removeAiVideoHandler}
                    loading={isVideoUploading}
                    fileType="video"
                  />
                </div>

                {/* ------- save button ---------- */}
                <div
                  className={`action d-flex ${
                    userInfo.role.slug === "ADMIN" ||
                    userInfo.role.slug === "SUPER_ADMIN"
                      ? "justify-content-between"
                      : "justify-content-end"
                  } `}
                >
                  <Link
                    to={
                      moduleName === "DOCTOR"
                        ? "/admin/clinicalmanagement/doctors"
                        : "/admin/clinicalmanagement/patients"
                    }
                    className={
                      userInfo.role.slug === "ADMIN" ||
                      userInfo.role.slug === "SUPER_ADMIN"
                        ? "btn btn-outline-primary"
                        : "d-none"
                    }
                  >
                    <span className="material-symbols-outlined align-middle me-1">
                      cancel
                    </span>{" "}
                    {t("Cancel")}
                  </Link>
                  <button
                    onClick={saveUserHandler}
                    type="button"
                    className="btn btn-primary"
                    disabled={isSaving ? true : false}
                    style={{
                      cursor: isSaving ? "not-allowed" : "pointer",
                    }}
                  >
                    <span className="material-symbols-outlined align-middle me-1">
                      save
                    </span>{" "}
                    {t("Save User")}
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                </div>
              </form>
            </div>
            {/* --- add/update section end----- */}
          </div>
        </section>

        <AfterSaveUserModal
          userId={savedUserId}
          afterSaveModalClose={afterModalClose}
          moduleName={moduleName === "DOCTOR" ? "Doctor" : "Patient"}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default CreateNewUserForm;
